import { Link, useParams } from "react-router";
import { getArticle } from "./wiki-content";
import { renderMarkdown } from "./markdown";

export function WikiArticleRoute() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticle(slug) : undefined;

  if (!article) {
    return (
      <section className="space-y-4">
        <p>Artikel nicht gefunden.</p>
        <Link to="/wiki" className="text-[color:var(--color-brand-accent)] underline">
          Zurück zur Übersicht
        </Link>
      </section>
    );
  }

  const html = renderMarkdown(article.body);

  return (
    <article className="prose-hp space-y-4 max-w-3xl">
      <Link to="/wiki" className="text-sm text-[color:var(--color-brand-accent)] underline">
        ← Wiki
      </Link>
      <header>
        <h1 className="text-3xl font-bold">{article.title}</h1>
        {article.lastUpdated && (
          <p className="text-xs text-neutral-500">Stand: {article.lastUpdated}</p>
        )}
      </header>
      <div
        className="space-y-3 text-base leading-7"
        // wiki-content ist build-time-trusted (alles aus content/wiki/), kein XSS-risiko
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <div className="mt-8 border-t border-[color:var(--color-border)] pt-4 no-print">
        <button
          type="button"
          onClick={() => window.print()}
          className="rounded-md border border-[color:var(--color-border)] px-4 py-2 text-sm font-medium hover:bg-[color:var(--color-surface-sunken)]"
        >
          Drucken
        </button>
      </div>
    </article>
  );
}
